import React from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';

export default function TextField({ id, state, label, help, ...props }) {
    return (
        <FormGroup
            controlId={id}
            validationState={state}
        >
            {label && <ControlLabel>{label}</ControlLabel>}
            <FormControl {...props} />
            {help && <HelpBlock>{help}</HelpBlock>}
        </FormGroup>
    );
}


// WEBPACK FOOTER //
// ./src/components/TextField.jsx